<template>
  <div>
    <v-toolbar
      id="core-toolbar"
      class="core-toolbar"
      flat
      prominent
      style="background: #eee"
      v-if="!checkCustomInstitute()"
    >
      <div
        v-if="this.onlineInstitute"
        class="mobile-display-logo"
        @click="onClickMobileLogo"
      >
        <img :src="mobileLogo" class="master-small-logo" />
      </div>
      <div class="v-toolbar-title">
        <v-toolbar-title class="font-weight-light text-general">
          <v-btn
            v-if="responsive"
            class="default v-btn--simple icon-btn"
            icon
            @click.stop="onClickBtn"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-toolbar-title>
      </div>
      <div class="mobileshow"></div>
      <div
        v-if="isTestStarted"
        :class="{ 'toolbar-section': true, show_menus: showMenu }"
      ></div>
      <div v-else :class="{ 'toolbar-section': true, show_menus: showMenu }">
        <div class="display-on-mobile">
          <div class="login-user-pic" @click="onEdit('profile')">
            <v-avatar class="avatar-vv">
              <img
                :src="user && user.profile_pic_url ? user.profile_pic_url : defaultPic"
                alt="profile image"
              />
            </v-avatar>
            <img src="../../assets/img/multimedi.png" class="edit-icon" />
          </div>
          <div class="login-user-name">
            Welcome! &nbsp; {{ user ? user.name : "Guest" }}
          </div>
        </div>
        <div
          v-for="(menu, index) in menus"
          :key="index"
          v-if="!menu.hideFromTop"
          class="menu-block"
          @click="onMenuClick(menu)"
          :disabled="buttonHovering == index || selectedMenu.css === menu.css"
          v-on:mouseover="onMouserHover(menu, index)"
          v-on:mouseleave="buttonHovering = -1"
        >
          <div
            v-if="buttonHovering === index"
            class="v-tooltip__content cust-new-tooltip-bottom open-bottom"
            style="opacity: 0; top: auto; z-index: 9999; bottom: 0"
          >
            <div>
              {{ menu.label }}
            </div>
          </div>

          <div :class="getCSS(menu.css)">
            <img :src="menu.icon" />
          </div>
          <div class="menu-name">
            {{ selectedMenu.css === menu.css ? menu.label : "&nbsp;" }}
          </div>
        </div>
        <div
          v-if="isDefaultInstitute && !myInstitute.is_white_labeled"
          class="cust-logo-on-mobile"
        >
          <v-img
            class="text-logo-img"
            src="../../assets/img/logo-footer.png"
            height="64"
            contain
          />
        </div>
      </div>
      <div class="login-user-name mb-hide" v-if="!isTestStarted && checkInstitute()">
        <div class="welcome-user">Welcome!</div>
        <div class="user-name-style">
          <v-tooltip left bottom content-class="cust-new-tooltip-top open-top">
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                depressed
                class="user-name-text"
                :class="{
                  'text-transform-none': true,
                }"
                >{{
                  user
                    ? innerWidth < 1210
                      ? user.name && user.name.length < 8
                        ? user.name
                        : user.name.substring(0, 7) + "..."
                      : innerWidth > 1210 && innerWidth < 1360
                      ? user.name && user.name.length < 10
                        ? user.name
                        : user.name.substring(0, 9) + "..."
                      : user.name && user.name.length < 27
                      ? user.name
                      : user.name.substring(0, 26) + "..."
                    : "Guest"
                }}</span
              >
            </template>
            <span>{{ user ? user.name : "Guest" }}</span>
          </v-tooltip>
        </div>
        <div class="user-font">{{ user ? getUsersRole(user) : "" }}</div>
      </div>
      <div
        class="login-user-pic mb-hide"
        @click="onEdit('profile')"
        v-if="!isTestStarted && checkInstitute()"
      >
        <v-avatar class="avatar-vv">
          <img
            :src="user && user.profile_pic_url ? user.profile_pic_url : defaultPic"
            alt="profile image"
          />
        </v-avatar>
        <div class="edit-profile">Edit Profile</div>
      </div>
      <v-icon
        @click="logOutUser"
        class="toolbar-items power-icon"
        v-if="!isTestStarted && checkInstitute()"
        >mdi-power</v-icon
      >
      <v-btn
        v-click-outside-view="doStuff"
        @click="showMenu = !showMenu"
        v-if="responsive && !isTestStarted && checkInstitute()"
        icon
        class="mobile-shoe-menu"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
      <v-btn
        v-click-outside-view="doStuff"
        v-if="!this.user && checkCustomInstitute()"
        icon
        class="mobile-shoe-menu"
        @click="login"
      >
        Login
      </v-btn>
      <div class="test-name-navbar" v-if="isTestStarted">
        {{ testDetails.test_name }}
      </div>
      <div
        v-if="
          isDefaultInstitute &&
          isShowLogo &&
          checkInstitute() && myInstitute &&
          !myInstitute.is_white_labeled
        "
        class="master-logo-block"
      >
        <img src="../../assets/img/Dashboard_logo.svg" class="master-logo" />
      </div>
    </v-toolbar>
    <!--myt user-->
    <v-toolbar
      id="core-toolbar"
      class="core-toolbar"
      flat
      prominent
      style="background: #eee"
      v-else
    >
      <div class="v-toolbar-title">
        <v-toolbar-title class="font-weight-light text-general">
          <v-btn
            v-if="responsive"
            class="default v-btn--simple icon-btn"
            icon
            @click.stop="onClickBtn"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-toolbar-title>
      </div>
      <div class="mobileshow"></div>
      <div
        v-if="isTestStarted"
        :class="{ 'toolbar-section': true, show_menus: showMenu }"
      ></div>
      <div v-else :class="{ 'toolbar-section': true, show_menus: showMenu }">
        <div
          v-for="(menu, index) in menus"
          :key="index"
          v-if="!menu.hideFromTop"
          class="menu-block"
          @click="onMenuClick(menu)"
          :disabled="buttonHovering == index || selectedMenu.css === menu.css"
          v-on:mouseover="onMouserHover(menu, index)"
          v-on:mouseleave="buttonHovering = -1"
        >
          <div :class="getCSS(menu.css)">
            <img :src="menu.icon" />
          </div>
          <div class="menu-name">
            {{ selectedMenu.css === menu.css ? menu.label : "&nbsp;" }}
          </div>
        </div>
      </div>
      <div class="login-user-name">
        <div class="welcome-user">Welcome, {{ user ? user.name : "Guest" }}</div>
      </div>

      <v-icon v-if="user" @click="logOutUser" class="toolbar-items power-icon"
        >mdi-power</v-icon
      >

      <v-btn
        v-click-outside-view="doStuff"
        v-if="!this.user && checkCustomInstitute()"
        icon
        class="mobile-show-menu login-menu sign-in-btn"
        @click="login"
      >
        Sign in
      </v-btn>
    </v-toolbar>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :data="alertBoxData"
      :status="status"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import vuex from "vuex";
import menuList from "../../utils/menu";
import menu from "../../utils/menu";
import constants from "@/utils/constants.js";
import moment from "moment";
import VueCookies from "vue-cookies";
Vue.use(VueCookies, { expire: "7d" });
export default {
  name: "Toolbar",
  data: () => ({
    responsive: false,
    showMenu: false,
    responsiveInput: false,
    menus: [],
    defaultPic: require("@/assets/img/default_user.png"),
    logo: "",
    mobileLogo: "",
    modules: [],
    isInstituteExpired: false,
    buttonHovering: false,
    showToolTip: false,
    isShowLogo: false,
    onlineInstitute: false,
    status: false,
    cComponent: "",
    modalwidth: "500px",
    alertBoxData: {},
    innerWidth: "",
  }),

  mounted() {
     if (localStorage.getItem("myInstitute") && JSON.parse(localStorage.getItem("myInstitute"))?.name !== 'myt') {
          this.getModules();
     }
    this.innerWidth = window.innerWidth;
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.onlineInstitute =
      this.myInstitute.id === this.ONLINE_INSTITUTE_ID ? true : false;
    this.logo = this.getInstituteLogo();
    this.mobileLogo = this.onlineInstitute ? this.getInstituteMobileLogo() : "";
    // this.updateMenuList();
    this.isShowLogo = constants.EXCLUDE_LOGO !== this.myInstitute.id;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    doStuff() {
      if (this.showMenu) {
        // console.log("====>", this.showMenu);
        this.showMenu = false;
      }
    },
    getUsersRole(item) {
      if (item.role_id === 5) {
        return "Institute Admin";
      } else if (item.role_id === 8) {
        return "Teacher";
      } else if (item.role_id === 9) {
        return item.roll_number ? "Roll No.: "+item.roll_number:"Student ID: " + item.id;
      } else if (item.role_id === 10) {
        return "Parent";
      } else if (item.role_id === 11) {
        return "System";
      } else if (item.role_id === 12) {
        return "Coordinator";
      } else if (item.role_id === 14) {
        return "Data Entry Operator (D.E.O)";
      } else {
        return "";
      }
    },
    onMenuClick(menu) {
      this.$router
        .replace({
          name: menu.toRoute,
          // params: { resetPage: true }
        })
        .catch(() => {});
    },
    onEdit(menu) {
      this.$router.push({ name: menu }).catch(() => {});
    },
    logOutUser() {
      localStorage.removeItem("modules");
      localStorage.removeItem("module-route");
      let user = this.user;
      let fn = "logOut";
      if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        fn = "logOutMyt";
      }
      this[fn]().then(() => {
        if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
          if (!localStorage.getItem("guest_user_id")) {
            localStorage.setItem("guest_user_id", "temp" + moment().format("X"));
          }
          let routeName = this.$route.name;
          if (routeName != "customized-tests-myt") {
            this.$router.push({ name: "customized-tests-myt" });
          }
        } else {
          this.$router.push({ name: "login" }).catch(() => {});
        }
      });
      if (
        this.myInstitute.id === this.ONLINE_INSTITUTE_ID &&
        (user.role_id === this.roleIds.ST || user.role_id === this.roleIds.PA)
      ) {
        localStorage.removeItem("user");
        localStorage.removeItem("auth_token");
        window.location.href = process.env.VUE_APP_REDIRECT_LOGIN_URL;
      }
    },
    ...mapActions({
      logOut: "userStore/logOut",
      logOutMyt: "userStore/logOutMyt",
      getUserPurchasedModules: "userStore/getUserPurchasedModules",
      loginMyt: "userStore/loginMyt",
      signupMyt: "userStore/signupMyt",
      verifyOtpMyt: "userStore/verifyOtpMyt",
    }),
    ...mapMutations("app", ["setDrawer", "onMenuSelected", "setMenus"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    getModules() {
      const reqData = {
        userId: this.user.id,
      };
      this.getUserPurchasedModules(reqData)
        .then(response => {
          this.modules = response;
          localStorage.setItem("modules", JSON.stringify(this.modules));
          this.updateMenuList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    async updateMenuList() {
      let excludeRoute = [];
      if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        this.menus = this.checkMenuList();
        let selectedMenu = this.menus.filter(m => m.toRoute === this.$route.name);
        this.onMenuSelected({
          main: selectedMenu && selectedMenu.length ? selectedMenu[0] : this.menus[0],
        });
      } else if (
        this.user &&
        (this.roleIds.CO === this.user.role_id || this.roleIds.ID === this.user.role_id)
      ) {
        this.menus = menuList.MENU.COORDINATOR;
        let menus = this.menus;
        this.isInstituteExpired = moment(this.myInstitute.expiry_date) < moment();
        let index = menus.findIndex(m => m.id === "CO-TEST");
        if (this.isInstituteExpired) {
          this.menus.map(m => {
            if (m.id !== "CO-HOME" && m.id != "CO-USER") {
              m.hideFromTop = true;
              m.hideFromDashBoard = true;
            }
            m.sub_menus.map(sm => {
              if (sm && sm.toRoute !== 'add-users' && sm.toRoute !== 'profile') {
                sm.hideFromDashBoard = true;
                sm.hideFromDrawer = true;
                sm.hideFromBreadCrumb = true;              
              } else {
                if (sm && sm.id == 1 && m.id !== "CO-HOME") {
                  m.toRoute = sm.toRoute;
                } else if (sm && sm.id == 1 && m.id == "CO-HOME") {
                  sm.toRoute = constants.INSTITUTE_EXPIRED_ROUTES[0];
                }
                if (sm && sm.id == 2 && m.id !== "CO-HOME") {
                  m.toRoute = sm.toRoute;
                } else if (sm && sm.id == 2 && m.id == "CO-HOME") {
                  sm.toRoute = constants.INSTITUTE_EXPIRED_ROUTES[1];
                }
              }
            });
          });
        } else {
          excludeRoute = constants.ROLE_WISE_ROUTE.IA;
        }
        index = this.menus.findIndex(m => m.id === "CO-EDIT-PROFILE");
        if (index >= 0) {
          let j = this.menus[index].sub_menus.findIndex(m => m.id === 1);
          this.menus[index].hideFromDashBoard = false;
          if (j >= 0) {
            this.menus[index].sub_menus[j].hideFromDashBoard =
              this.roleIds.ID === this.user.role_id ? false : true;
            this.menus[index].sub_menus[j].hideFromDrawer =
              this.roleIds.ID === this.user.role_id ? false : true;
          }
        }
      } else if (this.user && this.roleIds.ST === this.user.role_id) {
        this.menus = menuList.MENU.STUDENT;
        excludeRoute = this.isAltitudeInstitute()
          ? constants.ROLE_WISE_ROUTE.STC
          : constants.ROLE_WISE_ROUTE.ST;
        await this.getMeuns(constants.HIDE_MENU_FOR_ALTITUDE.ST);
      } else if (this.user && this.roleIds.PA === this.user.role_id) {
        this.menus = menuList.MENU.PARENT;
        excludeRoute = constants.ROLE_WISE_ROUTE.PA;
        await this.getMeuns(constants.HIDE_MENU_FOR_ALTITUDE.PA);
      } else if (this.user && this.roleIds.ED === this.user.role_id) {
        this.menus = menuList.MENU.DEO;
        excludeRoute = constants.ROLE_WISE_ROUTE.DEO;
      } else if (this.user && this.roleIds.TR === this.user.role_id) {
        this.menus = menuList.MENU.TEACHER;
        excludeRoute = constants.ROLE_WISE_ROUTE.TE;
      }
            this.menus.map(m => {
        let setroute = true;
        m.institute_ids = m.institute_ids ? JSON.parse(m.institute_ids):null;
        if (m.institute_ids&& m.institute_ids === this.myInstitute.id) {
          m.hideFromDashBoard = false;
          m.hideFromDrawer =  false;
        }
        if (!m.hideFromDashBoard&&!m.hideFromDrawer) {
          
          m.sub_menus.map(sm => {
            sm.institute_ids = sm.institute_ids ? JSON.parse(sm.institute_ids):null;
            let hideFromDashBoard = false;
            let isOnlinrInstitute = sm.institute_ids && sm.institute_ids === this.myInstitute.id;
            if (sm.institute_ids && sm.institute_ids === this.myInstitute.id) {
              sm.hideFromDashBoard = false;
              hideFromDashBoard = true
              sm.hideFromDrawer =  false;
            }
            let module = this.modules.find(
              md =>
                (md.module_id === sm.id ||
                  md.parent_module_id === sm.id ||
                  (sm.id == 9 && (md.module_id === sm.id || md.module_id === 13))) &&
                md.is_selected
            );
            if (!module && sm.id && !hideFromDashBoard) {
              sm.hideFromDrawer = true;
              sm.hideFromDashBoard = true;
            } else {
              sm.hideFromDrawer =!hideFromDashBoard  &&isOnlinrInstitute  ?sm.hideFromDrawer:false;
              sm.hideFromDashBoard = !hideFromDashBoard & isOnlinrInstitute?sm.hideFromDashBoard:false;
              if (sm.hideFromInstitute && !isOnlinrInstitute) {
                sm.hideFromDashBoard = true;
                sm.hideFromDrawer =  true;
              }
              if (setroute && !m.id.includes("HOME")) {
                const index = this.menus[0].sub_menus.findIndex(
                  mb => mb.toRoute === m.toRoute
                );
                m.toRoute = sm.toRoute;
                index > -1 ? (this.menus[0].sub_menus[index].toRoute = sm.toRoute) : "";
                setroute = false;
              }
            }
          });
        }
      });
      // Excluding the routes which are not allowed for the user to visit
      this.menus.map(m => {
        if (!m.hideFromDashBoard && !m.hideFromTop && m.toRoute != "profile") {
          excludeRoute.push(m.toRoute);
        }
        m.sub_menus.map(sm => {
          if (!sm.hideFromDrawer && !sm.hideFromDashBoard) {
            excludeRoute.push(sm.toRoute);
            if (sm.sub_pages && sm.sub_pages) {
              sm.sub_pages.map(pg => {
                excludeRoute.push(pg);
              });
            }
          }
        });
      });
      this.setMenus(this.menus);
      sessionStorage.setItem("excludeRoute", JSON.stringify(excludeRoute));
    },
    onClickMobileLogo() {
      if (this.myInstitute.id === this.ONLINE_INSTITUTE_ID) {
        window.location.href = process.env.VUE_APP_REDIRECT_LOGIN_URL;
      } else {
        this.$router.push({ name: "home" }).catch(() => {});
      }
    },
    checkMenuList() {
      if (this.user && this.user.id) {
        return menuList.MENU.CUSTOMMENU;
      } else {
        let menu = menuList.MENU.CUSTOMMENU;
        let updatedMenu = [];
        for (const key in menu) {
          if (menu.hasOwnProperty(key) && menu[key].id !== "MY-TEMPLATE") {
            updatedMenu[key] = menu[key];
          }
        }
        if (this.$route.name == "my-template") {
          this.$router.push({ name: "customized-tests-myt" });
        }
        return updatedMenu;
      }
    },
    onMouserHover(menu, index) {
      this.buttonHovering = this.selectedMenu.css !== menu.css ? index : -1;
    },
    getMeuns(hideMenus) {
      if (this.isAltitudeInstitute()) {
        this.menus.map(m => {
          if (hideMenus.includes(m.name)) {
            m.hideFromTop = true;
            m.hideFromDashBoard = true;
            m.sub_menus.map(sm => {
              sm.hideFromDashBoard = true;
              sm.hideFromDrawer = true;
              sm.hideFromBreadCrumb = true;
            });
          }
          m.sub_menus.map(sm => {
            if (sm && hideMenus.includes(sm.name)) {
              sm.hideFromDashBoard = true;
              sm.hideFromDrawer = true;
              sm.hideFromBreadCrumb = true;
            }
          });
        });
      }
      return;
    },
    checkInstitute() {
      return this.user ? true : !this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id);
    },
    checkCustomInstitute() {
      return this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id);
    },
    login() {
      this.cComponent = "components/CustomInstituteComponents/Login/MYTLogin";
      this.status = true;
    },
    onClose(data) {
      // this.status = data.status;

      if (data && data.login) {
        this.mytLogin(data.mobileNumber, data.password);
      } else if (data && data.verify_otp) {
        this.verifyOtp(data);
      } else if (data && data.edit) {
        this.cComponent = "components/CustomInstituteComponents/Login/MYTLogin";
        this.alertBoxData = data;
      } else {
        this.status = data.status;
        this.alertBoxData = {};
      }
    },
    mytLogin(mobileNumber, password) {
      this.$sh;
      let reqData = {
        phone: this.getMobileNumberWithCountryCode(
          mobileNumber.countryCode,
          mobileNumber.number
        ),
        password: password,
      };
      this.loginMyt(reqData)
        .then(res => {
          if (password) {
            this.status = false;
          } else {
            this.cComponent = "components/CustomInstituteComponents/Login/LoginOTP";
            this.alertBoxData = res.user;
            this.alertBoxData.resendOtp = res.resend_otp_time;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    verifyOtp(data) {
      let reqData = {
        phone: data.phone,
        otp: data.otp.slice(0, 6),
        user_id: localStorage.getItem("guest_user_id"),
        register_id: data ? data.id : null,
      };
      this.verifyOtpMyt(reqData)
        .then(res => {
          if (res.isNewUser) {
            this.cComponent = "components/CustomInstituteComponents/Login/MYTRegister";
            this.alertBoxData = res.user;
          } else {
            this.status = false;
            this.alertBoxData = {};
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState("userStore", ["user", "isDefaultInstitute", "myInstitute"]),
    ...mapState("app", ["selectedMenu"]),
    ...mapState("testStore", ["isTestStarted", "testDetails"]),
    getCSS() {
      return css_name => {
        let css = `toolbar-item ${css_name} ${
          this.selectedMenu.css === css_name ? "active" : ""
        }`;
        return css;
      };
    },
    getUserPic() {
      return user && user.profile_pic_url ? user.profile_pic_url : this.defaultPic;
    },
  },
  watch: {
    buttonHovering(val) {
      this.showToolTip = val;
    },
    user(val) {
      if (val && val.id) {
        this.updateMenuList();
      } else {
        this.updateMenuList();
      }
    },
  },
};
</script>
